import { ConsumerType } from '../../../types/application/contact';

export const ConsumerTypeDTO = {
  ASSISTANT: 'Assistant',
  OWNER_OR_DIRECTOR: 'Owner or Director',
};

export function getConsumerTypeFromDTO(consumerType?: string): ConsumerType | undefined {
  if (consumerType) {
    switch (consumerType) {
      case ConsumerTypeDTO.OWNER_OR_DIRECTOR:
        return ConsumerType.DIRECTOR;
      case ConsumerTypeDTO.ASSISTANT:
        return ConsumerType.ASSISTANT;
      default:
        throw new Error(`Integration revamp: unknown consumer type: ${consumerType}`);
    }
  }
}

export function getDTOFromConsumerType(consumerType?: ConsumerType): string | undefined {
  if (consumerType !== undefined) {
    switch (consumerType) {
      case ConsumerType.ASSISTANT:
        return ConsumerTypeDTO.ASSISTANT;

      case ConsumerType.DIRECTOR:
        return ConsumerTypeDTO.OWNER_OR_DIRECTOR;

      default:
        throw new Error(`Integration revamp: unknown consumer type: ${consumerType}`);
    }
  }
}
